module.exports = __webpack_public_path__ + "img/stammbasis.4571b00d.svg";